// @flow

import RatesTermsAndConditions from './terms-and-conditions'

export default RatesTermsAndConditions
